import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconTrendingUp } from '@blocks-react/components/Icons/TrendingUp';
import styles from './WarningToolTip.module.scss';
import { Conditional } from '../conditional';
export interface IAppProps {
  isToolTip: boolean;
  toolTipHeading?: string;
  toolTipDescription: string;
  tooltipHandler?: () => void;
}

export const WarningToolTip = (props: IAppProps) => {
  const {
    isToolTip = false,
    toolTipHeading,
    toolTipDescription,
    tooltipHandler
  } = props;

  return (
    <div>
      {isToolTip ? (
        <CatTooltip>
          <CatButton
            hideText
            size="xs"
            slot="trigger"
            variant="ghost"
            className={styles['service_recommendation__btn']}
            onClick={tooltipHandler}
          >
            <CatIconTrendingUp
              slot="after"
              className={styles['service_recommendation_icon']}
              size="sm"
            />
          </CatButton>
          <div className={styles['service_recommendation__tooltip']}>
            <Conditional test={!!toolTipHeading}>
              <CatHeading
                slot="trigger"
                variant="label-sm"
                data-testid="tooltip-heading"
              >
                {toolTipHeading}
              </CatHeading>
            </Conditional>
            <CatHeading slot="trigger" variant="footnote">
              {toolTipDescription}
            </CatHeading>
          </div>
        </CatTooltip>
      ) : (
        <CatIconTrendingUp
          className={styles['service_recommendation_icon']}
          size="sm"
          slot="trigger"
          onClick={tooltipHandler}
        />
      )}
    </div>
  );
};
